module.exports = __webpack_public_path__ + "img/title_bg2.e3cc9f96.png";